<template>
  <div class="qualityContain">
    <div class="listContent">
      <el-dialog title="切换工程" :visible.sync="dialogTableVisible">
        <el-table :data="projList">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="address" label="工程地址"></el-table-column>
          <el-table-column label="设置" width="150">
            <template slot-scope="scope">
              <span
                class="setProject"
                @click="toActive(scope.row.id)"
                v-if="scope.row.active == 0"
                >设为当前工程</span
              >
              <span class="lookMore" v-if="scope.row.active == 1"
                >当前工程</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <div class="changeText">当前工程：{{ nowPro }}</div>
      <el-button
        class="changePro"
        type="primary"
        @click="openProjectSelector"
        plain
        >切换工程</el-button
      >
      <div class="searchCon searchContent">
        <span class="searchInputText">道路</span>
        <el-select v-model="roadInfo" placeholder="请选择道路">
          <el-option
            v-for="item in roadList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <span class="searchInputText">作业层</span>
        <el-select v-model="roadLayer" placeholder="请选择作业层">
          <el-option
            v-for="item in roadLayerList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <span class="searchInputText" v-if="projectTypeShow == 0">作业路幅</span>
        <el-select v-model="roadWidth" placeholder="请选择作业路幅" v-if="projectTypeShow == 0">
          <el-option
            v-for="item in roadWidthList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="danger" @click="doSearchClick">确认</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>
      <div class="qualityConNo" v-show="!haveWork">无作业数据</div>
      <div class="qualityCon" v-show="haveWork">
        <div class="projectInfo">
          <div class="blockHeader">
            <div class="redBlock"></div>
            <div class="headerText">作业列表</div>
            <div class="workListTable" id="nav">
              <span
                class="workItem"
                v-for="(item, index) in works"
                :key="item.id"
                :class="{ activeWorkItem: index == workIndex }"
                @click="workClick(item.id,item.name, index)"
              >
                <span class="workItemText">{{ item.name }}</span>
              </span>
            </div>
          </div>
          <div
            class="line"
            style="
              height: 1px;
              background-color: #e1e1e1;
              width: 100%;
              margin: 0 auto;
            "
          ></div>
          <div class="blockContent" style="margin-top: 24px">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">作业类型</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.workType"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{workTypeList[workObj.workType]}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业标段</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.sectionName"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.sectionName
                  }}</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">作业设备</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.equipNames"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.equipNames
                  }}</span>
                </div>
              </div>
              
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">作业创建时间</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.createTime"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.createTime
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业开工时间</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.startTime"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.startTime
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业计划竣工时间</div>
                <div class="itemRight">
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.planEndTime
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业实际完成时间</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.endTime"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.endTime
                  }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">施工单位</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.consUnit"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.consUnit
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">监理单位</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.supervisor"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.supervisor
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业负责人</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.principal"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.principal
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业联系电话</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.principalPhone"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow"
                    >{{workObj.principalPhone}}</span
                  >
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1" v-show="
                  this.workObj.workType == 3 || this.workObj.workType == 4
                ">
                <div class="itemLeft">作业总里程</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.sumMileage"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.sumMileage
                  }}km</span>
                </div>
              </div>
              <div class="item_type1" v-show="
                  this.workObj.workType == 1 || this.workObj.workType == 2
                ">
                <div class="itemLeft">作业总面积</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.sumArea"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.sumArea
                  }}M²</span>
                </div>
              </div>
              <div class="item_type1" v-show="
                  this.workObj.workType == 3 || this.workObj.workType == 4
                ">
                <div class="itemLeft">作业已完成里程</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.curMileage"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">
                    {{ workObj.curMileage }}km
                  </span>
                </div>
              </div>
              <div class="item_type1" v-show="
                  this.workObj.workType == 1 || this.workObj.workType == 2
                ">
                <div class="itemLeft">作业已完成面积</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.sumArea"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{ workObj.curArea }}M²</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业起始桩号</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.startPileNum"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.startPileNum
                  }}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业结束桩号</div>
                <div class="itemRight">
                  <el-input
                    v-if="isLook"
                    class="infoShow"
                    v-model="workObj.endPileNum"
                  ></el-input>
                  <span v-if="!isLook" class="infoShow">{{
                    workObj.endPileNum
                  }}</span>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <div class="tabContent">
          <div
            @click="tabChange(0)"
            class="tabItem"
            :class="[tabCode == 0 ? 'itemActive' : '']"
          >
            碾压质量<span class="line" v-if="tabCode == 0"></span>
          </div>
          <div
            @click="tabChange(1)"
            class="tabItem"
            :class="[tabCode == 1 ? 'itemActive' : '']"
          >
            摊铺质量<span class="line" v-if="tabCode == 1"></span>
          </div>
          <div
            @click="tabChange(2)"
            class="tabItem"
            :class="[tabCode == 2 ? 'itemActive' : '']"
          >
            报警<span class="line" v-if="tabCode == 2"></span>
          </div>
          <div style="clear: both"></div>
        </div>

        <div class="processCon" v-if="tabCode != 2">
          <div class="noDataShow" v-show="workChartShow==false && timeChartShow==false">暂无数据</div>
          <div class="processLT" v-if="standardWork == 1">
            <span class="circle"></span>
            <span class="processTitle">作业进度</span>
            <span class="sectionName">{{
              workProcess.standardWorkData
                ? workProcess.standardWorkData.sectionName
                : ""
            }}</span>
            <el-tooltip
              class="sectionNameShow"
              :style="{}"
              effect="dark"
              :content="workProcess.standardWorkData
                ? workProcess.standardWorkData.sectionName
                : ''"
              placement="top-start"
              ><el-button></el-button
            ></el-tooltip>
            <div class="progressB"></div>
            <span class="pile_1">{{
              workProcess.standardWorkData.sectionStartPile
            }}</span>
            <span class="pile_2">{{
              workProcess.standardWorkData.sectionEndPile
            }}</span>
            <el-tooltip
              class="progressC"
              :style="{
                width:
                  (Math.abs(
                    workProcess.standardWorkData.workEndMileage -
                      workProcess.standardWorkData.workStartMileage
                  ) *
                    880) /
                    workProcess.standardWorkData.sumMileage +
                  'px !important',
                left:
                  workProcess.standardWorkData.workStartMileage <
                  workProcess.standardWorkData.workEndMileage
                    ? (Math.abs(
                        workProcess.standardWorkData.workStartMileage -
                          workProcess.standardWorkData.sectionStartMileage
                      ) *
                        880) /
                        workProcess.standardWorkData.sumMileage +
                      472 +
                      'px'
                    : (Math.abs(
                        workProcess.standardWorkData.workEndMileage -
                          workProcess.standardWorkData.sectionEndMileage
                      ) *
                        880) /
                        workProcess.standardWorkData.sumMileage +
                      472 +
                      'px',
              }"
              effect="dark"
              :content="
                '已施工:' +
                workProcess.standardWorkData.curMileage +
                ',' +
                '未施工:' +
                Math.abs(
                  workProcess.standardWorkData.sumMileage -
                    workProcess.standardWorkData.curMileage
                ) +
                ',' +
                '进度:' +
                workProcess.standardWorkData.process +
                '%'
              "
              placement="top-start"
              ><el-button
                :style="{
                  width:
                    (Math.abs(
                      workProcess.standardWorkData.workEndMileagee -
                        workProcess.standardWorkData.workStartMileage
                    ) *
                      880) /
                      workProcess.standardWorkData.sumMileage +
                    'px !important',
                }"
              ></el-button
            ></el-tooltip>
          </div>
          <div class="processLT" v-if="standardWork == 2">
            <span class="circle"></span>
            <span class="processTitle">作业进度</span>
            <span class="sectionName">{{
              workProcess.nonStandardWorkData
                ? workProcess.nonStandardWorkData.sectionName
                : ""
            }}</span>
            <div class="progressB"></div>
            <!-- <span class="pile_1">{{
              workProcess.standardWorkData.sectionStartPile
            }}</span>
            <span class="pile_2">{{
              workProcess.standardWorkData.sectionEndPile
            }}</span> -->
            <el-tooltip
              class="progressC"
              :style="{
                width:
                  Math.abs(workProcess.nonStandardWorkData.process / 100) *
                    880 +
                  'px !important',
                left: 472 + 'px',
              }"
              effect="dark"
              :content="
                '已施工:' +
                workProcess.nonStandardWorkData.curArea +
                ',' +
                '未施工:' +
                Math.abs(
                  workProcess.nonStandardWorkData.sumArea -
                    workProcess.nonStandardWorkData.curArea
                ) +
                ',' +
                '进度:' +
                workProcess.nonStandardWorkData.process +
                '%'
              "
              placement="top-start"
              ><el-button
                :style="{
                  width:
                    (Math.abs(
                      workProcess.nonStandardWorkData.curArea /
                        workProcess.nonStandardWorkData.sumArea
                    ) *
                      880) /
                      workProcess.nonStandardWorkData.sumArea +
                    'px !important',
                }"
              ></el-button
            ></el-tooltip>
          </div>
          <div class="processLB" v-if="workProcess.timeProcess">
            <span class="circle"></span>
            <span class="processTitle">时间进度</span>
            <span class="restDaysT">{{workProcess.timeProcess.restDays?(workProcess.timeProcess.restDays>=0?'倒计时':'已延期'):'倒计时'}}</span>
            <span class="restDays"
              >{{ Math.abs(workProcess.timeProcess.restDays) || '--'
              }}<span style="font-size: 16px"> 天</span></span
            >
            <div class="progressB"></div>
            <span class="pile_1">{{ workProcess.timeProcess.startDate }}</span>
            <span class="pile_2">{{
              workProcess.timeProcess.planEndDate
            }}</span>
            <div
              class="progressCF"
              :style="{
                width:
                  (workProcess.timeProcess.process / 100) * 880 +
                  'px !important',
              }"
            ></div>
          </div>
          <div class="processPie" v-show="workChartShow==true || timeChartShow==true">
            <div class="workChart" id="workChart" v-show="workChartShow"></div>
            <div class="timeChart" id="timeChart" v-show="timeChartShow"></div>
          </div>
        </div>
        <div :class="[tabCode != 0 ? 'tabShowClass' : '']">
          <QualityRoll :workId="workId" :workName="workName"></QualityRoll>
        </div>
        <div :class="[tabCode != 1 ? 'tabShowClass' : '']">
          <QualityPav :workId="workId" :workName="workName"></QualityPav>
        </div>

        <!-- 报警模块 -->
        <div class="warnContent" v-if="tabCode == 2">
          <div class="warnSearch">
            <span class="searchInputText">日期</span>
            <el-date-picker
              size="medium"
              v-model="duration"
              @change="dateChange"
              type="daterange"
              range-separator="—"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <span class="searchInputText">报警内容</span>
            <el-input
              placeholder="请输入报警内容"
              v-model="search.content"
            ></el-input>
            <span class="searchInputText">报警设备</span>
            <el-select v-model="search.equipName" placeholder="请选择报警设备">
              <el-option
                v-for="item in warnEquipList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <el-button type="danger" @click="doSearchClickWarn">确认</el-button>
            <el-button type="info" @click="resetSearchWarn" plain
              >重置</el-button
            >
          </div>

          <div class="listContain">
            <div class="tablelistBody">
              <el-table
                :data="dataList"
                style="width: 100%"
                size="medium"
                :cell-class-name="cellcb"
              >
                <el-table-column
                  prop="order"
                  label="序号"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="content"
                  label="报警内容"
                  width=""
                ></el-table-column>
                <el-table-column
                  prop="equipName"
                  label="报警设备"
                  width=""
                ></el-table-column>
                <el-table-column prop="workStatus" label="报警时设备状态">
                  <template slot-scope="scope">
                    <span class="wordStatus_1" v-if="scope.row.status == 0"
                      >离线</span
                    >
                    <span class="wordStatus_2" v-if="scope.row.status == 1"
                      >怠速</span
                    >
                    <span class="wordStatus_3" v-if="scope.row.status == 2"
                      >作业中</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="startTime"
                  label="开始报警时间"
                  width=""
                ></el-table-column>
                <el-table-column
                  prop="endTime"
                  label="解除报警时间"
                  width=""
                ></el-table-column>
                <el-table-column
                  prop="duration"
                  label="持续报警时长"
                  width=""
                ></el-table-column>
                <el-table-column
                  prop="address"
                  label="报警地点"
                  width=""
                ></el-table-column>
                <el-table-column
                  prop="gps"
                  label="报警GPS坐标"
                  width=""
                ></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <el-pageCover
          class="pageBlock"
          :pageMsg="pageMsg"
          @sizeChange="pageSizeChange"
          @currentChange="currentPageChange"
          v-if="tabCode == 2"
        ></el-pageCover>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEnginList,
  getWorksByZ,
  getWorkInfo,
  activeEngin,
  getRoadAndLayerByProjectId,
  getWorkProcess,
  getRecordWarningList as fetchDtList,
} from "../../utils/api";
import { getNowDataNum, dateFormat } from "../../utils/commons";
import QualityRoll from "../../components/engineering/qualityRoll.vue";
import QualityPav from "../../components/engineering/qualityPav.vue";

import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";

import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      workChartShow: true,
      timeChartShow: true,
      workTypeList: {
            0: '未选择',
            11: '手动压实',
            21: '手动摊铺压实',
            1: '智能压实',
            2: '无人压实',
            3: '智能摊铺压实',
            4: '无人摊铺压实'
        },
      haveWork: true,
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      dialogTableVisible: false,
      projList: [],
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/engineeringCenter",
        },
        {
          name: "作业质量",
          path: "",
        },
      ],
      nowPro: "",
      projectId: "",
      roadInfo: "",
      roadLayer: "",
      roadWidth: "",

      roadList: [
        {
          value: "",
          label: "全部",
        },
      ],
      roadLayerList: [
        {
          value: "",
          label: "全部",
        },
      ],
      roadWidthList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "左幅",
          label: "左幅",
        },
        {
          value: "右幅",
          label: "右幅",
        },
      ],

      roadAllList: [],
      roadAllLayerList: [],

      works: [],
      workObj: {},
      workIndex: 0,
      tabCode: 0,
      isLook: false,
      workChart: "",
      timeChart: "",
      workProcess: {
        standardWorkData: {},
        timeProcess: {},
        nonStandardWorkData: {},
      },
      workId: "",
      workName: "",

      warnEquip: "",
      warnEquipList: "",
      duration: "",
      search: {
        pageSize: 10,
        pageNo: 1,
      },
      startDate: "",
      endDate: "",
      standardWork: 0, //false 非标  true 标准
      // workIndex: '',
      projectTypeShow: '',
    };
  },
  watch: {
    roadInfo: function (newValue) {
      console.log(newValue);
      let list = this.roadAllList;
      let setLayer = [
        {
          value: "",
          label: "全部",
        },
      ];
      for (let i = 0; i < list.length; i++) {
        if (newValue == list[i].roadId) {
          let layList = list[i].layerList;
          for (let j = 0; j < layList.length; j++) {
            setLayer.push({
              value: layList[j].layerId,
              label: layList[j].layerName,
            });
          }
        }
      }
      this.roadLayerList = setLayer;
    },
    projectId: function (newValue) {
      //console.log(newValue)
      let params = {
        projectId: newValue,
      };
      let that = this;
      that.activeCode = 1;
      getRoadAndLayerByProjectId(params).then((res) => {
        console.log(res);
        this.roadAllList = res.data.content.dataList;
        let list = res.data.content.dataList;
        let setRoad = [
          {
            value: "",
            label: "全部",
          },
        ];

        for (let i = 0; i < list.length; i++) {
          setRoad.push({
            value: list[i].roadId,
            label: list[i].roadName,
          });
        }
        this.roadInfo = "";
        this.roadLayer = "";
        this.roadWidth = "";
        this.roadList = setRoad;
        this.workChange();
      });
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    const echarts = require("echarts5");
    this.workChart = echarts.init(document.getElementById("workChart"));
    this.timeChart = echarts.init(document.getElementById("timeChart"));
    this.getProjectList();
  },
  methods: {
    fetchDtList,
    dateChange(e) {
      console.log(e);
      if (e == null) {
        this.startDate = "";
        this.endDate = "";
      } else {
        this.startDate = dateFormat(e[0], "YYYY-MM-DD");
        this.endDate = dateFormat(e[1], "YYYY-MM-DD");
      }
    },
    openProjectSelector() {
      this.dialogTableVisible = true;
      // this.getProjectList();
    },
    tabChange(e) {
      this.tabCode = e;
      let setId = JSON.parse(JSON.stringify(this.workId));
      this.workId = "1";
      this.workId = setId;
      if (e == 2) {
        this.doSearch();
      }
    },
    getProjectList() {
      // 获取条件筛选数据

      getEnginList({ pageSize: 1000 }, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
        const currentProject = (this.projList || []).find(
          (item) => item.active == 1
        );
        this.projectId = currentProject.id;
        this.nowPro = currentProject.name;
        this.projectTypeShow = currentProject.projectType
        this.$store.commit("setProjectId", this.projectId);
      });
    },
    toActive: function (setId) {
      let params = {
        id: setId,
      };
      activeEngin(params).then((res) => {
        console.log(res);
        this.getProjectList();
      });
    },
    doSearchClick() {
      this.workChange();
    },
    doSearchClickWarn() {
      this.search.workId = this.workId;
      this.search.startDate = this.startDate;
      this.search.endDate = this.endDate;
      this.getDataList(this.search, { listKey: "list" });
    },
    resetSearchWarn() {
      this.duration = "";
      this.search = {
        pageSize: 10,
        pageNo: 1,
        workId: this.workId
      };
      this.getDataList(this.search, { listKey: "list" });
    },
    doSearch: function () {
      this.search.workId = this.workId;
      this.search.startDate = this.startDate;
      this.search.endDate = this.endDate;
      this.getDataList(this.search, { listKey: "list" });
    },
    resetSearch() {
      this.roadInfo = "";
      this.roadLayer = "";
      this.roadWidth = "";
      this.workChange();
    },
    workClick(id,name, index) {
      let that = this;
      this.workIndex = index;
      this.workId = id;
      this.workName = name;
      this.tabCode = 0;
      getWorkInfo({ id: id }).then((res) => {
        let roadWidth = res.data.content.info.roadWidth;
        let deviationUnit = res.data.content.info.deviationUnit;
        let setRoadWidth = [];
        let code = deviationUnit;
        for (let i = 0; i < 100; i++) {
          if (i * code <= roadWidth * 1 + code * 1) {
            setRoadWidth.push((code * 10 * i) / 10);
          }
        }
        this.workObj = res.data.content.info;
        let workTypeList = this.$store.state.workTypeList;
        let statusList = this.$store.state.statusList;
        this.workObj.workTypeText = workTypeList[this.workObj.workType];
        this.workObj.statusText = statusList[this.workObj.status];
        //标准道路
        this.workObj.pecent =
          this.workObj.sumMileage == 0
            ? "0.0%"
            : (
                (this.workObj.curMileage / this.workObj.sumMileage) *
                100
              ).toFixed(1) + "%";
        this.workObj.surplus = getNowDataNum(this.workObj.planEndTime);

        let gList = res.data.content.info.equipNames.split(",");
        let sList = [];
        for (let i = 0; i < gList.length; i++) {
          sList.push({
            value: gList[i],
            label: gList[i],
          });
        }
        this.warnEquipList = sList;
        console.log(this.warnEquipList);
      });
      getWorkProcess({ workId: id }).then((res) => {
        console.log(res);
        this.standardWork = res.data.content.info.standardWork ? 1: 2;
        this.workProcess = res.data.content.info;
        if (
          this.workProcess.nonStandardWorkData == null &&
          this.workProcess.standardWorkData == null
        ) {
          this.$message({
            message: "无作业进度数据",
            type: "warning",
          });
          this.standardWork = 0;
          this.workChartShow = false
        } else {
          this.workChartShow = true
          let workOption = this.getOption(
            this.standardWork == 1
              ? res.data.content.info.standardWorkData.process
              : res.data.content.info.nonStandardWorkData.process,
            "作业进度",
            "#6DD400"
          );

          that.workChart.setOption(workOption);
        }

        if (this.workProcess.timeProcess == null) {
          this.$message({
            message: "无时间进度数据",
            type: "warning",
          });
          this.timeChartShow = false
        } else {
          this.timeChartShow = true
          let timeOption = this.getOption(
            res.data.content.info.timeProcess.process,
            "时间进度",
            "#F7B500"
          );
          that.timeChart.setOption(timeOption);
        }
      });
    },
    workChange() {
      let that = this;
      let params = {
        projectId: this.projectId,
        roadId: this.roadInfo,
        layerId: this.roadLayer,
        roadWay: this.roadWidth,
      };
      getWorksByZ(params).then((res) => {
        //console.log(res)
        if (res.data.content.dataList.length == 0) {
          this.haveWork = false;
        } else {
          this.haveWork = true;
          that.works = res.data.content.dataList;
          if (res.data.content.dataList.length > 0) {
            let par = {
              id: res.data.content.dataList[0].id,
            };
            this.workId = res.data.content.dataList[0].id;
            // this.workId = 290;
            this.workName = res.data.content.dataList[0].name;
            getWorkInfo(par).then((res) => {
              let roadWidth = res.data.content.info.roadWidth;
              let deviationUnit = res.data.content.info.deviationUnit;
              let setRoadWidth = [];
              let code = deviationUnit;
              for (let i = 0; i < 100; i++) {
                if (i * code <= roadWidth * 1 + code * 1) {
                  setRoadWidth.push((code * 10 * i) / 10);
                }
              }
              this.workObj = res.data.content.info;
              let workTypeList = this.$store.state.workTypeList;
              let statusList = this.$store.state.statusList;
              this.workObj.workTypeText = workTypeList[this.workObj.workType];
              this.workObj.statusText = statusList[this.workObj.status];
              //标准道路
              this.workObj.pecent =
                this.workObj.sumMileage == 0
                  ? "0.0%"
                  : (
                      (this.workObj.curMileage / this.workObj.sumMileage) *
                      100
                    ).toFixed(1) + "%";
              this.workObj.surplus = getNowDataNum(this.workObj.planEndTime);
              let gList = res.data.content.info.equipNames.split(",");
              let sList = [];
              for (let i = 0; i < gList.length; i++) {
                sList.push({
                  value: gList[i],
                  label: gList[i],
                });
              }
              this.warnEquipList = sList;
              console.log(this.warnEquipList);
            });
            getWorkProcess({ workId: that.workId }).then((res) => {
              console.log(res);
              this.standardWork = res.data.content.info.standardWork?1:2;
              this.workProcess = res.data.content.info;
              if (
                this.workProcess.nonStandardWorkData == null &&
                this.workProcess.standardWorkData == null
              ) {
                this.$message({
                  message: "无作业进度数据",
                  type: "warning",
                });
                this.standardWork = 0;
                this.workChartShow = false
              } else {
                this.workChartShow = true
                let workOption = this.getOption(
                  this.standardWork == 1
                    ? res.data.content.info.standardWorkData.process
                    : res.data.content.info.nonStandardWorkData.process,
                  "作业进度",
                  "#6DD400"
                );

                that.workChart.setOption(workOption);
              }

              if (this.workProcess.timeProcess == null) {
                this.$message({
                  message: "无时间进度数据",
                  type: "warning",
                });
                this.timeChartShow = false
              } else {
                this.timeChartShow = true
                let timeOption = this.getOption(
                  res.data.content.info.timeProcess.process,
                  "时间进度",
                  "#F7B500"
                );
                that.timeChart.setOption(timeOption);
              }
            });
          }
        }
      });
    },

    getOption(e, n, c) {
      let option = {
        series: [
          {
            type: "gauge",
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false,
            },
            center: ["50%", "50%"],
            radius: "100%",
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              width: 10,
              itemStyle: {
                color: c,
                borderWidth: 1,
                borderColor: c,
              },
            },
            axisLine: {
              lineStyle: {
                width: 10,
              },
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              distance: 50,
            },
            data: [
              {
                value: e,
                name: n,
                title: {
                  offsetCenter: ["0%", "30%"],
                  color: "rgba(0, 0, 0, 0.5)",
                  fontSize: 16,
                },
                detail: {
                  offsetCenter: ["0%", "-10%"],
                },
              },
            ],
            title: {
              fontSize: 14,
            },
            detail: {
              width: 50,
              height: 40,
              fontSize: 30,
              color: "#000000",
              // borderColor: 'auto',
              // borderRadius: 20,
              // borderWidth: 1,
              formatter: "{value}%",
            },
          },
        ],
      };
      return option;
    },
  },
  components: {
    QualityRoll,
    QualityPav,
    ElPageCover,
  },
};
</script>
<style lang="scss">
.warnSearch {
  .el-input {
    width: 224px;
    margin-left: 16px;
  }
  .el-date-editor {
    margin-left: 16px;
  }
  .el-input__inner {
    // margin-left: 16px;
  }
  .el-button {
    margin-left: 16px;
  }
}
</style>
<style lang="scss" scoped="">
.listContent {
  height: auto;
  width: 98.5%;
  margin: 0 auto;
  //   background-color: #ffffff;
  position: relative;
  padding-top: 63px;
  .searchCon {
    width: 100%;
    height: 63px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .qualityConNo {
    width: 100%;
    height: 700px;
    background-color: #ffffff;
    padding: 0 24px;
    line-height: 700px;
    text-align: center;
    font-size: 20px;
  }
  .qualityCon {
    width: 100%;
    height: auto;
    background-color: #ffffff;
    padding: 0 24px;
    .tabContent {
      width: 100%;
      height: 48px;
      background: rgba(0, 0, 0, 0.03);
      border: 1px solid rgba(0, 0, 0, 0.05);
      .tabItem {
        width: 112px;
        height: 100%;
        float: left;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        position: relative;
        .line {
          width: 64px;
          height: 2px;
          background: #f56c6c;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
        }
      }
      .itemActive {
        background-color: #ffffff;
        color: #f56c6c;
      }
    }
    .tabShowClass {
      position: fixed;
      top: -10000px;
    }
    .processCon {
      width: 100%;
      height: 208px;
      position: relative;
      .noDataShow{
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
      .processLT {
        width: 1368px;
        height: 104px;
        position: absolute;
        top: 0;
        left: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      }
      .processLB {
        width: 1368px;
        height: 104px;
        position: absolute;
        bottom: 0;
        left: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      }
      .processPie {
        width: 457px;
        height: 208px;
        position: absolute;
        bottom: 0;
        right: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .workChart {
          height: 160px;
          width: 160px;
          position: absolute;
          top: 24px;
          left: 34px;
        }
        .timeChart {
          height: 160px;
          width: 160px;
          position: absolute;
          top: 24px;
          right: 34px;
        }
      }
      .circle {
        width: 8px;
        height: 8px;
        background-color: #f56c6c;
        border-radius: 4px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
      }
      .processTitle {
        position: absolute;
        display: inline-block;
        height: 22px;
        line-height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        top: 50%;
        transform: translateY(-50%);
        left: 16px;
      }
      .sectionName {
        position: absolute;
        display: inline-block;
        height: 22px;
        line-height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        top: 50%;
        transform: translateY(-50%);
        left: 150px;
        width: 320px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .sectionNameShow{
        position: absolute;
        display: inline-block;
        height: 22px;
        top: 50%;
        transform: translateY(-50%);
        left: 150px;
        width: 320px;
        z-index: 10;
        opacity: 0;
      }
      .restDaysT {
        position: absolute;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        top: 23px;
        left: 150px;
      }
      .restDays {
        position: absolute;
        display: inline-block;
        height: 28px;
        line-height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        top: 51px;
        left: 150px;
      }
      .progressB {
        position: absolute;
        width: 880px;
        height: 12px;
        background: rgba(0, 0, 0, 0.1);
        top: 32px;
        left: 472px;
      }
      .progressC {
        height: 12px !important;
        top: 0;
        position: absolute;
        background-color: #6dd400 !important;
        z-index: 100;
        top: 32px;
        margin: 0 !important;
        border: none !important;
        padding: 0 !important;
      }
      .progressCF {
        height: 12px !important;
        position: absolute;
        background-color: #f7b500 !important;
        z-index: 100;
        top: 32px;
        left: 472px;
        margin: 0 !important;
        border: none !important;
        padding: 0 !important;
      }
      .pile_1 {
        display: inline-block;
        position: absolute;
        line-height: 17px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        top: 55px;
        left: 472px;
      }
      .pile_2 {
        display: inline-block;
        position: absolute;
        line-height: 17px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        top: 55px;
        right: 16px;
      }
    }
    .warnContent {
      width: 100%;
      height: auto;
      .warnSearch {
        width: 100%;
        height: 80px;
        padding-top: 20px;
      }
    }
    .projectInfo {
      height: auto;
      padding-bottom: 24px;
      margin: 0 auto;
      background-color: #ffffff;
      .blockHeader {
        width: 100%;
        height: 58px;
        position: relative;
        .workListTable {
          width: 1600px;
          height: 40px;
          position: absolute;
          top: 15px;
          left: 130px;
          // background-color: aquamarine;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;

          .workItem {
            &.activeWorkItem {
              background-color: #e96b5a;
              .workItemText {
                color: #ffffff;
              }
            }
            color: #e96b5a;
            background: #fdf0ef;
            border-color: #f6c4bd;
            height: 32px;
            width: auto;
            display: inline-block;
            line-height: 30px;
            font-size: 14px;

            margin-right: 10px;
            margin-left: 10px;
            // padding: 0 30px;
            vertical-align: top;
            border: 1px solid #e96b5a;
            box-sizing: border-box;
            transform: skewX(-20deg);
            cursor: pointer;
            .workItemText {
              display: inline-block;
              height: 100%;
              width: 100%;
              padding: 0 30px;
              line-height: 30px;
              transform: skewX(20deg);
            }
          }
        }
        .redBlock {
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #e96b5a;
          top: 19px;
          left: 0px;
        }
        .headerText {
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 14px;
          font-weight: 600;
          font-size: 16px;
        }

        .addBtn {
          // position: absolute;
          // top: 15px;
          // right: 171px;
          float: right;
          border-radius: 2px;
          margin-top: 15px;

          span {
            font-size: 12px !important;
          }
        }

        .copyBtn {
          // position: absolute;
          // top: 15px;
          // right: 85px;
          float: right;
          border-radius: 2px;
          margin-top: 15px;
          margin-left: 12px;
        }
        .download {
          // position: absolute;
          // top: 15px;
          // right: 0px;
          float: right;
          border-radius: 2px;
          margin-top: 15px;
          margin-left: 12px;
        }
      }
      .parameterContent {
        width: 97.7%;
        height: auto;
        margin: 0 auto;
      }
      .blockContent {
        margin: 0 auto;
        border-top: 1px solid rgba(225, 225, 225, 1);
        border-left: 1px solid rgba(225, 225, 225, 1);

        .blockItem {
          display: flex;
          height: 45px;
          .item_type1 {
            flex: 1;
          }
          .item_type2 {
            flex: 2;
          }
          .itemLeft {
            width: 120px;
            height: 44px;
            float: left;
            background: rgba(242, 242, 245, 1);
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);
            line-height: 44px;
            padding-left: 15px;
            color: #555555;
            font-size: 14px;
          }
          .itemRight {
            // width: 100%;
            height: 44px;
            line-height: 44px;
            padding-left: 18px;
            color: #555555;
            font-size: 14px;

            overflow: hidden;
            border-bottom: 1px solid rgba(225, 225, 225, 1);
            border-right: 1px solid rgba(225, 225, 225, 1);
            .infoShow {
              width: 100%;
              height: 100%;
              border: 0;
              color: #555555;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .changePro {
    position: absolute;
    width: 88px;
    height: 32px;
    text-align: center;
    // line-height: 30px;
    font-size: 14px;
    // background: rgba(245, 108, 108, 0.1);
    // border-radius: 2px;
    // border: 1px solid #F56C6C;
    // color: #F56C6C;
    // cursor: pointer;
    right: 0;
    top: -45px;
    z-index: 500;
  }
}
.changeText {
  line-height: 28px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  right: 112px;
  top: -42px;
  z-index: 500;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}
</style>